import React from "react";
import { CompaniesAvailableResponse } from "@/main/models/response/announcementResponse";
import * as S from "./styles";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import KogCheckbox from "@/main/components/shared/checkbox/kogCheckbox";
import { Controller, useFormContext } from "react-hook-form";
import { AnnouncementCompaniesSaveRequest } from "@/main/models/request/announcementRequest";
import { getTranslateByKey } from "@/main/services/utils";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";

interface ICompaniesWillSeeGrid {
	dataCompanies: CompaniesAvailableResponse[];
	isLoading: boolean;
	isLoadingPagination: boolean;
	hasMore: boolean;
	loadMore: () => void;
}

const ID_SCROLLABLE_TARGET = "id-scrollable-target-companiesWillSee";

export default function CompaniesWillSeeGrid({
	dataCompanies,
	isLoading,
	isLoadingPagination,
	hasMore,
	loadMore,
}: ICompaniesWillSeeGrid) {
	const { control, setValue, watch } = useFormContext<AnnouncementCompaniesSaveRequest>();

	const selectedCompanies: string[] = watch("guidCompanies") || [];

	const handleSelectAll = (checked: boolean) => {
		const allGuids = checked ? dataCompanies.map((c) => c.guid) : [];
		setValue("guidCompanies", allGuids);
	};

	const rowHeaders = (
		<S.ContainerHeaderGrid>
			<S.GridCell style={{ fontWeight: "bold", color: "gray" }}>
				{getTranslateByKey("information.rfcCompany")}
			</S.GridCell>
			<S.GridCell style={{ fontWeight: "bold", color: "gray" }}>
				{getTranslateByKey("information.companyType")}
			</S.GridCell>
			<KogCheckbox
				checked={selectedCompanies.length === dataCompanies.length && dataCompanies.length > 0}
				onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
					handleSelectAll(event.target.checked);
				}}
				id="id-registerInsurer-checkbox-selectAll"
			/>
		</S.ContainerHeaderGrid>
	);

	if (isLoading) return <LoadingComponent />;

	return (
		<S.ContainerScroll id={ID_SCROLLABLE_TARGET}>
			<BoxGrid
				rowHeaders={[rowHeaders]}
				typeGrid="default"
				sizeCell="medium"
				infiniteScrollConfig={{
					dataLength: dataCompanies.length,
					fetchData: () => loadMore(),
					hasMore: hasMore,
					isLoading: isLoadingPagination,
					idScrollTarget: ID_SCROLLABLE_TARGET,
				}}
				marginCustom="0.3rem 0 0 0"
			>
				{dataCompanies.map((company) => (
					<S.ContainerGrid key={company.guid}>
						<S.GridCell>
							<span
								title={`${company.companyRegistrationNumber} / ${company.companyName}`}
								style={{
									display: "block",
									overflow: "hidden",
									textOverflow: "ellipsis",
									whiteSpace: "nowrap",
								}}
							>
								{`${company.companyRegistrationNumber} / ${company.companyName}`}
							</span>
						</S.GridCell>
						<S.GridCell>{company.companyTypeName}</S.GridCell>

						<Controller
							control={control}
							name="guidCompanies"
							render={({ field }) => {
								const checked = field.value?.includes(company.guid) || false;
								return (
									<KogCheckbox
										checked={checked}
										onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
											const isChecked = event.target.checked;
											const newValue = isChecked
												? [...(field.value || []), company.guid]
												: (field.value || []).filter((g) => g !== company.guid);
											field.onChange(newValue);
										}}
										id={`id-companiesWillSee-checkbox-${company.guid}`}
									/>
								);
							}}
						/>
					</S.ContainerGrid>
				))}
			</BoxGrid>
		</S.ContainerScroll>
	);
}
